/**
 * Утилиты для работы с сессией и авторизацией
 */

export function isSessionExpiredError(error: any): boolean {
  if (!error.response) return false

  const { status, data, headers } = error.response

  if (status === 400) {
    const isSessionError =
      headers['x-session-expired'] === 'true' ||
      (data && (
        data.message?.includes('session') ||
        data.message?.includes('token') ||
        data.message?.includes('auth') ||
        data.error?.includes('session') ||
        data.error?.includes('token') ||
        data.error?.includes('auth')
      ))

    return isSessionError
  }

  if (status === 401) return true
  if (status === 403) return true

  return false
}

export function isNetworkError(error: any): boolean {
  return !error.response && error.request
}

export function isServerError(error: any): boolean {
  return error.response && error.response.status >= 500
}
